export default __webpack_public_path__ + "static/media/speech_bubble.35ac5d68.svg";